import React from 'react';
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';

export default function FeatureGrid({ blok }) {
  return (
    <section className="my-20 md:my-36">

      {/* Purge classname */}
      <div className="hidden h-48" />

      <div className="container">
        {blok.textCard?.length > 0 && (
          <div className={`flex mb-12 lg:mb-16 ${blok.textCard[0].textAlign === 'center' && 'justify-center'}`}>
            <TextCard blok={blok.textCard[0]} />
          </div>
        )}

        <div className="flex flex-wrap justify-center -mb-8 md:-ml-10">
          {blok.features?.length > 0 &&
            blok.features.map((feature, i) => (
              <div key={feature._uid} className={`w-full sm:w-1/2 md:w-1/3 md:flex justify-start md:justify-center md:pl-10 mb-12 md:mb-8`}>
                <SbEditable content={feature} key={feature._uid}>
                  <div
                    className={`flex flex-col ${feature.className} ${
                      feature.textAlign === 'center' && 'text-center align-center'
                    }`}
                  >
                    {feature.icon?.filename && (
                      <div className={`flex ${feature.textAlign === 'center' && 'justify-center'}`}>
                        <img
                          className={`select-none inline-block mb-6 ${feature.iconClass || ' h-20 md:h-24 '}`}
                          draggable={false}
                          src={feature.icon.filename}
                          alt={feature.icon.alt}
                        />
                      </div>
                    )}
                    {feature.heading && (
                      <h4 className="mb-3 text-h4" dangerouslySetInnerHTML={{ __html: feature.heading }} />
                    )}
                    {feature.content && (
                      <div className="">
                        <div
                          className={`prose md:max-w-sm md:max-w-none ${feature.contentClass}`}
                          dangerouslySetInnerHTML={{ __html: feature.content }}
                        />
                      </div>
                    )}
                  </div>
                </SbEditable>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
